import script from "./vehiclePage.vue?vue&type=script&setup=true&lang=js"
export * from "./vehiclePage.vue?vue&type=script&setup=true&lang=js"

import "./vehiclePage.vue?vue&type=style&index=0&id=10ed2b8c&lang=css"

const __exports__ = script;

export default __exports__